export default __webpack_public_path__ + "static/media/march2023-4.6f498365.jpg";